import classnames from 'classnames';

import { Div } from './HTMLElement';
import { t } from './i18n/i18n';
import { PropsWithCustomComponent, VariantsController } from './VariantsController';

export interface CountdownProps {
  blockClassNames?: string;
  blockStyle?: React.CSSProperties;
  classNames?: string;
  days: number;
  hours: number;
  labelClassNames?: string;
  labelStyle?: React.CSSProperties;
  minutes: number;
  seconds: number;
  style?: React.CSSProperties;
  valueClassNames?: string;
  valueStyle?: React.CSSProperties;
}

const Countdown = ({ classNames, days, hours, minutes, seconds, style, ...otherProps }: CountdownProps) => {
  return (
    <Div className={classnames('countdown', classNames)} style={style}>
      <Block
        {...otherProps}
        blockClassNames={classnames('days', otherProps.blockClassNames)}
        label={t('misc.time.days', { count: days })}
        labelClassNames={classnames('label', otherProps.labelClassNames)}
        value={days}
        valueClassNames={classnames('value', otherProps.valueClassNames)}
      />
      <Block
        {...otherProps}
        blockClassNames={classnames('hours', otherProps.blockClassNames)}
        label={t('misc.time.hours', { count: hours })}
        labelClassNames={classnames('label', otherProps.labelClassNames)}
        value={hours}
        valueClassNames={classnames('value', otherProps.valueClassNames)}
      />
      <Block
        {...otherProps}
        blockClassNames={classnames('minutes', otherProps.blockClassNames)}
        label={t('misc.time.minutes', { count: minutes })}
        labelClassNames={classnames('label', otherProps.labelClassNames)}
        value={minutes}
        valueClassNames={classnames('value', otherProps.valueClassNames)}
      />
      <Block
        {...otherProps}
        blockClassNames={classnames('seconds', otherProps.blockClassNames)}
        label={t('misc.time.seconds', { count: seconds })}
        labelClassNames={classnames('label', otherProps.labelClassNames)}
        value={seconds}
        valueClassNames={classnames('value', otherProps.valueClassNames)}
      />
    </Div>
  );
};

interface BlockProps {
  blockClassNames?: string;
  blockStyle?: React.CSSProperties;
  label: string;
  labelClassNames?: string;
  labelStyle?: React.CSSProperties;
  value: number;
  valueClassNames?: string;
  valueStyle?: React.CSSProperties;
}

const Block = ({
  blockClassNames,
  blockStyle,
  label,
  labelClassNames,
  labelStyle,
  value,
  valueClassNames,
  valueStyle,
}: BlockProps) => (
  <Div className={blockClassNames} style={blockStyle}>
    <Div className={valueClassNames} style={valueStyle}>
      {value}
    </Div>
    <Div className={labelClassNames} style={labelStyle}>
      {label}
    </Div>
  </Div>
);

export type CountdownVariants = '';

const CountdownController = (props: PropsWithCustomComponent<CountdownProps>) => (
  <VariantsController<CountdownProps, CountdownVariants>
    {...props}
    variantsControllerConfig={{
      defaultComponent: Countdown,
      name: 'Countdown',
    }}
  />
);
export { CountdownController as Countdown };
